/**
 * @generated SignedSource<<b818d059d63fcd03090a75a34639053e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type BookingDurationCourtInnerQuery$variables = {
  agendaId: string;
  bookingId: string;
  bookingType: BookingType;
  courseId: string;
  memberId: string;
  slotId: string;
  startTime: string;
};
export type BookingDurationCourtInnerQuery$data = {
  readonly node: {
    readonly courseBucket?: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"useGetCourseOptions_CourseBucket">;
    } | null | undefined;
  } | null | undefined;
  readonly slotNode: {
    readonly " $fragmentSpreads": FragmentRefs<"CourtsControlFragment" | "useGetValidCourseAndDurationSelections_Node">;
  } | null | undefined;
};
export type BookingDurationCourtInnerQuery = {
  response: BookingDurationCourtInnerQuery$data;
  variables: BookingDurationCourtInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agendaId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "courseId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "bookingId",
      "variableName": "bookingId"
    },
    {
      "kind": "Variable",
      "name": "bookingType",
      "variableName": "bookingType"
    },
    {
      "kind": "Variable",
      "name": "memberId",
      "variableName": "memberId"
    }
  ],
  "concreteType": "EndSlotOptionsConnection",
  "kind": "LinkedField",
  "name": "endSlotOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EndSlotOptionsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowedPlayerCounts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availability",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "agendaId",
    "variableName": "agendaId"
  },
  {
    "kind": "Variable",
    "name": "startsAt",
    "variableName": "startTime"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxDurationMins",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "FacilityCopyOverrides",
  "kind": "LinkedField",
  "name": "copyOverrides",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NounOverride",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "singular",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingDurationCourtInnerQuery",
    "selections": [
      {
        "alias": "slotNode",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useGetValidCourseAndDurationSelections_Node"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CourtsControlFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseBucket",
                "kind": "LinkedField",
                "name": "courseBucket",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useGetCourseOptions_CourseBucket"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Course",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookingDurationCourtInnerQuery",
    "selections": [
      {
        "alias": "slotNode",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Course",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PublicBookingPermissionSet",
                        "kind": "LinkedField",
                        "name": "publicBookingPermissionSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customerCanSelectCourt",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucket",
                    "kind": "LinkedField",
                    "name": "courseBucket",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": (v14/*: any*/),
                        "concreteType": "SlotDurations",
                        "kind": "LinkedField",
                        "name": "slotDurations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlot",
                            "kind": "LinkedField",
                            "name": "startSlot",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Course",
                                "kind": "LinkedField",
                                "name": "course",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "course",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseBucket",
                        "kind": "LinkedField",
                        "name": "courseBucket",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "SlotDurations",
                            "kind": "LinkedField",
                            "name": "slotDurations",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlot",
                                "kind": "LinkedField",
                                "name": "startSlot",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Course",
                                    "kind": "LinkedField",
                                    "name": "course",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseBucket",
                "kind": "LinkedField",
                "name": "courseBucket",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": (v14/*: any*/),
                    "concreteType": "SlotDurations",
                    "kind": "LinkedField",
                    "name": "slotDurations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "startSlot",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Course",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v17/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Course",
            "abstractKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc5147d90729646c544b3b767a546ba5",
    "id": null,
    "metadata": {},
    "name": "BookingDurationCourtInnerQuery",
    "operationKind": "query",
    "text": "query BookingDurationCourtInnerQuery(\n  $courseId: ID!\n  $startTime: Time!\n  $agendaId: ID!\n  $slotId: ID!\n  $bookingType: BookingType!\n  $memberId: ID!\n  $bookingId: ID!\n) {\n  slotNode: node(id: $slotId) {\n    __typename\n    ...useGetValidCourseAndDurationSelections_Node\n    ...CourtsControlFragment\n    id\n  }\n  node(id: $courseId) {\n    __typename\n    ... on Course {\n      courseBucket {\n        id\n        ...useGetCourseOptions_CourseBucket\n      }\n    }\n    id\n  }\n}\n\nfragment CourtsControlFragment on Slot {\n  __isSlot: __typename\n  id\n  ... on TimeSlot {\n    ...useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot\n    course {\n      id\n      name\n      description\n    }\n  }\n  agenda {\n    facility {\n      copyOverrides {\n        course {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useGetCourseOptionsFromValidCustomerBookingSelections_TimeSlot on TimeSlot {\n  id\n  endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n    edges {\n      durationMins\n      allowedPlayerCounts\n      node {\n        availability\n        id\n      }\n    }\n  }\n  course {\n    id\n    name\n    description\n    facility {\n      publicBookingPermissionSet {\n        customerCanSelectCourt\n        id\n      }\n      copyOverrides {\n        course {\n          singular\n        }\n      }\n      id\n    }\n    courseBucket {\n      id\n      slotDurations(agendaId: $agendaId, startsAt: $startTime) {\n        startSlot {\n          id\n          time\n          course {\n            id\n            name\n            description\n          }\n          endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n            edges {\n              durationMins\n              allowedPlayerCounts\n              node {\n                availability\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useGetCourseOptions_CourseBucket on CourseBucket {\n  slotDurations(startsAt: $startTime, agendaId: $agendaId) {\n    startSlot {\n      id\n      course {\n        name\n        description\n        id\n      }\n    }\n    maxDurationMins\n  }\n}\n\nfragment useGetValidCourseAndDurationSelections_Node on Node {\n  __isNode: __typename\n  ...useValidDurationsNode\n  ... on TimeSlot {\n    id\n    agenda {\n      id\n    }\n    time\n    course {\n      id\n      name\n      facility {\n        publicBookingPermissionSet {\n          customerCanSelectCourt\n          id\n        }\n        id\n      }\n      courseBucket {\n        id\n        slotDurations(agendaId: $agendaId, startsAt: $startTime) {\n          startSlot {\n            id\n            course {\n              id\n              name\n            }\n            endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n              edges {\n                durationMins\n                allowedPlayerCounts\n                node {\n                  id\n                  time\n                  availability\n                }\n              }\n            }\n          }\n          maxDurationMins\n        }\n      }\n    }\n  }\n}\n\nfragment useValidDurationsNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n      edges {\n        durationMins\n        allowedPlayerCounts\n        node {\n          id\n          time\n          availability\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bda158d11949644717da9ce17ff650b";

export default node;
